import React, { useState, useEffect } from 'react';
import { getTokenUsage, TokenUsageResponse } from '../services/api';

const TokenUsage = () => {
  const [tokenUsage, setTokenUsage] = useState<TokenUsageResponse | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchTokenUsage = async () => {
    try {
      setLoading(true);
      const fetchedTokenUsage = await getTokenUsage();
      if (fetchedTokenUsage) {
        setTokenUsage(fetchedTokenUsage);
      }
    } catch (err: any) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTokenUsage();
  }, []);

  if (loading) {
    return <p className="text-center mt-5">Cargando uso de tokens...</p>;
  }

  if (error) {
    return <div className="alert alert-danger mt-5">{error}</div>;
  }

  return (
    <div className="card">
      <div className="card-body">
        <h5 className="card-title">Uso de Tokens</h5>
        {tokenUsage && (
          <ul className="list-group list-group-flush">
            <li className="list-group-item">Total de Tokens: {tokenUsage.total_tokens}</li>
            <li className="list-group-item">Tokens de Prompt: {tokenUsage.prompt_tokens}</li>
            <li className="list-group-item">Tokens de Completado: {tokenUsage.completion_tokens}</li>
          </ul>
        )}
      </div>
    </div>
  );
};

export default TokenUsage;
